import { Radio, Monitor, Copy, File, Heart, Users, ArrowUpRight, type LucideIcon } from 'lucide-react'
import { features } from '@/lib/chirp-data'

const icons: Record<string, LucideIcon> = {
  radio: Radio,
  monitor: Monitor,
  copy: Copy,
  file: File,
  heart: Heart,
  users: Users,
}

export function Features() {
  return (
    <section id="features" className="border-b border-border/60 pt-4 pb-12 md:pt-6 md:pb-16">
      <div className="mx-auto max-w-7xl px-4">
        <div className="max-w-2xl">
          <span className="font-mono text-sm text-primary">// what it does</span>
          <h2 className="mt-3 text-balance text-3xl font-bold tracking-tight sm:text-4xl">
            Everything you need to manage your radio&apos;s memory
          </h2>
          <p className="mt-4 text-pretty leading-relaxed text-muted-foreground">
            NewChirp focuses on one job and does it well: reading, editing, and writing the memory of
            your radio without the clunky proprietary software.
          </p>
        </div>

        <div className="mt-12 grid gap-px overflow-hidden rounded-xl border border-border bg-border sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => {
            const Icon = icons[feature.icon] ?? Radio
            const cardContent = (
              <>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-border bg-background text-primary transition-colors group-hover:border-primary/40">
                  <Icon className="h-5 w-5" />
                </span>
                <div className="mt-4 flex items-start justify-between gap-2">
                  <h3 className="text-lg font-semibold">{feature.title}</h3>
                  <ArrowUpRight className="h-4 w-4 shrink-0 text-muted-foreground transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-primary" />
                </div>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  {feature.description}
                </p>
              </>
            )

            return feature.href ? (
              <a
                key={feature.title}
                href={feature.href}
                className="group block bg-card p-6 transition-colors hover:bg-secondary/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50"
              >
                {cardContent}
              </a>
            ) : (
              <div
                key={feature.title}
                className="group bg-card p-6 transition-colors hover:bg-secondary/60"
              >
                {cardContent}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
